module.exports = __webpack_public_path__ + "img/imweb_design_4.b813ab44.png";